<template>
  <vs-popup title="متصدیان فروشِ نماینده" :active.sync="popupActive">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <div v-if="loading">
          <div id="loading-grid">
            <svg
              class="spinner"
              width="65px"
              height="65px"
              viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                class="path"
                fill="none"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
              ></circle>
            </svg>
          </div>
        </div>
        <div v-else>
          <vs-table
            v-if="listSalePersons.length"
            :data="listSalePersons"
            class="custom-tbl"
          >
            <template slot="thead">
              <th>#</th>
              <th>{{ $t("ContractName") }}</th>
              <th>{{ $t("ProductSegment") }}</th>
              <th>{{ $t("SalePersonName") }}</th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(salePerson, i) in data">
                <vs-td>
                  {{ i + 1 }}
                </vs-td>
                <vs-td>
                  {{ salePerson.contractTinyInfo.contractTitle }}
                </vs-td>
                <vs-td>
                  {{ salePerson.segmentTinyInfo.segmentName }}
                </vs-td>
                <vs-td>
                  {{ salePerson.salePerson.salePersonFullName }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <label for="" v-else>
            این نماینده در حال حاضر هیچ متصدی فروشی ندارد.
          </label>
        </div>
      </div>
    </div>
    <!-- </vs-tab> -->
  </vs-popup>
</template>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
export default {
  name: "",
  props: {
    show: { default: false },
    agentId: { default: "" },
  },
  data() {
    return {
      title: "",
      serialService: "",
      listSalePersons: [],
      loading: false,
    };
  },
  computed: {
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    ...mapActions({
      SaleAgentsRelatedSalesPersonById: "sale/SaleAgentsRelatedSalesPersonById",
    }),
    deleteMemberInAgent(ownerId, partyId) {
      this.$swal({
        title: "آیا از حذف این عضو اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          var model = {
            agentId: partyId,
            ownerId: ownerId,
          };
          this.removeUserToAgents(model).then(() => {});
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.loading = true;
        this.SaleAgentsRelatedSalesPersonById(this.agentId).then((r) => {
          this.loading = false;
          this.listSalePersons = r;
        });
      } else {
        this.listSalePersons = [];
      }
    },
  },
};
</script>
